import useAPI from '@/pages/members/hooks/useAPI';
import {
  TreatableSubstanceParams,
  TreatableSubstanceRepository
} from '@/repositories/members/TreatableSubstanceRepository';

import { ONBOARDING_QUERY_KEY_PREFIX } from '../pages/Onboarding/components/Stepper';

export const useTreatableSubstances = ({ jurisdiction }: TreatableSubstanceParams) => {
  const treatableSubstanceRepository = TreatableSubstanceRepository();

  return useAPI({
    queryKey: [ONBOARDING_QUERY_KEY_PREFIX, 'treatableSubstances', jurisdiction],
    queryFn: () => treatableSubstanceRepository.list({ jurisdiction }),
    refetchOnWindowFocus: false
  });
};
